var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwssns({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "257px",
    viewBox: "0 0 256 257",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M98.875,232.033 L72.442,224.625 L47.441,196.117 L78.713,195.254 L98.875,232.033",
    fill: "#995B80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.75,213.233 L22.875,209.067 L8.817,193.033 L25.899,190.224 L37.75,213.233",
    fill: "#995B80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,191.017 L15.204,194.108 L17.411,190.226 L17.411,58.503 L15.204,55.942 L0,64.6 L0,191.017",
    fill: "#7B3F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.933,69.708 L15.208,55.942 L15.208,194.108 L24.006,193.29 L37.75,213.233 L48.35,191.028 L73.933,188.65 L73.933,69.708",
    fill: "#C17B9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.958,198.133 L60.021,203.383 L61.737,199.338 L61.737,37.44 L60.021,33.775 L33.958,46.983 L33.958,198.133",
    fill: "#7B3F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.734,81.516 L60.021,33.775 L60.021,203.387 L77.242,201.171 L98.875,232.033 L116.001,196.183 L208.734,184.25 L208.734,81.516",
    fill: "#C17B9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.833,256.492 L144.267,245.967 L108.758,205.467 L154.791,204.999 L181.833,256.492",
    fill: "#995B80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.591,208.95 L127.921,216.367 L130.898,213.801 L130.898,4.117 L127.921,0 L89.591,19.158 L89.591,208.95",
    fill: "#7B3F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,64.033 L127.925,0 L127.925,216.367 L150.522,211.839 L181.833,256.492 L208.734,200.183 L208.717,200.181 L256,190.708 L256,64.033",
    fill: "#C17B9D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwssns);
export default __webpack_public_path__ + "static/media/AWS SNS.b30d9bd11a19b0ef284ec468046c4a36.svg";
export { ForwardRef as ReactComponent };